// extracted by mini-css-extract-plugin
module.exports = {"Container":"CreateBoard_Container__N1JGG","Heading":"CreateBoard_Heading__33M-X"};